import { createTypes } from "@/store/utils";

export const FETCH_TEMPLATES_LIST = createTypes("FETCH_TEMPLATES_LIST");
export const FETCH_TEMPLATE = createTypes("FETCH_TEMPLATE");
export const CREATE_TEMPLATE = createTypes("CREATE_TEMPLATE");
export const DELETE_TEMPLATE = createTypes("DELETE_TEMPLATE");
export const FETCH_STATIC_TEMPLATE = createTypes("FETCH_STATIC_TEMPLATE");
export const UPDATE_TEMPLATE = createTypes("UPDATE_TEMPLATE");
export const TRIGGER_TEST_PREVIEW = createTypes("TRIGGER_TEST_PREVIEW");
